module.exports = __webpack_public_path__ + "img/Z81_12.6bc4b10d.jpg";